import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { classNames } from "@utils/classNames";

interface Props {
  heading?: string;
  availableTags: { id: string; label: string }[];
  name: string;
  type?: "checkbox" | "radio";
}

export const TagsMenu: FC<Props> = ({
  heading,
  availableTags,
  name,
  type = "checkbox",
}) => {
  // Get form context.
  const { watch, setValue } = useFormContext();

  // Get currently assigned tags.
  const assignedTags: string[] = watch(name);

  // Method: toggleAssignedTag.
  const toggleAssignedTag = (tag: string) => {
    const isTagIncludedInAssignedTags = assignedTags?.includes(tag);

    const newAssignedTags =
      type === "radio"
        ? assignedTags?.filter(
            (assignedTag) =>
              availableTags.findIndex(({ id }) => id === assignedTag) === -1
          )
        : assignedTags;

    if (isTagIncludedInAssignedTags) {
      setValue(
        name,
        newAssignedTags.filter((assignedTag) => assignedTag !== tag),
        {
          shouldValidate: false,
        }
      );
    } else {
      setValue(name, [...newAssignedTags, tag], {
        shouldValidate: false,
      });
    }
  };

  return (
    <fieldset className="">
      {heading && <div className="mb-1 text-sm font-medium">{heading}</div>}
      <div className="">
        {availableTags.map((tag, i) => (
          <button
            key={tag.id}
            type="button"
            className={classNames(
              "relative mb-1 px-2 py-1 text-xs font-medium hover:z-10",
              assignedTags?.includes(tag.id)
                ? "text-white bg-black/100 hover:text-white"
                : "text-gray-500 bg-black/5 hover:text-black hover:bg-black/10 ",
              type === "checkbox" && "mr-1 rounded",
              type === "radio" && "-mr-px",
              type === "radio" && i === 0 ? "rounded-l" : "",
              type === "radio" && i === availableTags.length - 1
                ? "rounded-r"
                : ""
            )}
            onClick={() => {
              toggleAssignedTag(tag.id);
            }}
          >
            {tag.label || tag.id}
          </button>
        ))}
      </div>
    </fieldset>
  );
};
